import { render } from "./ProductSalesHistory.vue?vue&type=template&id=61320a14&scoped=true"
import script from "./ProductSalesHistory.vue?vue&type=script&lang=js"
export * from "./ProductSalesHistory.vue?vue&type=script&lang=js"

import "./ProductSalesHistory.vue?vue&type=style&index=0&id=61320a14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61320a14"]])

export default __exports__